<template>
  <div class="synonyms">
    <div class="columns">
      <div class="column">
        <h2 class="is-size-5">Synonyms</h2>
      </div>
      <div class="column has-text-right">
            <button class="button" @click="getSynonyms()">Get Synonyms</button>
      </div>
    </div>
    <p class="has-text-white">Simply use your mouse to select / highlight a word on the page and press 'Get Synonyms'. Magic.</p>
    <div v-if="synonyms">
      <div v-for="synonym in synonyms.data.result" :key="synonym.id">
        <Synonym :synonym="synonym"/>
      </div>
    </div>
  </div>
</template>

<script>
const config = require('../config');
import axios from 'axios';
import Synonym from './Synonym';

export default {
  name: 'Synonyms',
  data() {
    return {
      synonyms: null
    }
  },
  components: {
    Synonym
  },
  methods: {
    async getSynonyms() {
      const word = window.getSelection().toString();
      const api = await axios.get(`https://www.abbreviations.com/services/v2/syno.php?uid=${config.abbreviations_uid}&tokenid=${config.abbreviations_tokenid}&word=${word}&format=json`)
                  .then(function ( response ) {
                    return response;
                  })
                  .catch( function ( error ) {
                    // console.log ( error );
                    alert ( error );
                  });

      this.synonyms = api;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

h2 {
  color: white;
}
</style>
